import React from 'react';

import { AsyncSelect } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';

import { textifyError } from 'src/lib/error';

class SelectBase extends React.Component {
  state = {
    loadingError: null
  };
  debounceTimer = null;

  componentWillUnmount() {
    this.setState = () => {};
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = null;
  }

  onLoad = (text, callback) => {
    const { loadOptions, debounceTimeout = 1000 } = this.props;
    if (this.state.loadingError) {
      this.setState({ loadingError: null });
    }

    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.debounceTimer = null;

      loadOptions(text, callback)
        .then(callback)
        .catch(loadingError => {
          this.setState({ loadingError });
          callback([]);
        });
    }, debounceTimeout);
  };

  render() {
    const { loadOptions, debounceTimeout, className, onChange, name, ...rest } = this.props;
    const newProps = {};

    if (className) {
      newProps.className = className;
      newProps.classNamePrefix = className;
    }

    return (
      <div>
        <AsyncSelect
          loadOptions={this.onLoad}
          isClearable
          cacheOptions
          defaultOptions
          {...newProps}
          {...rest}
          onChange={onChange ? value => { onChange({ target: { value, name } }); } : () => {} }
        />
        <div style={{ color: token('color.text.danger', 'red') }}>
          {this.state.loadingError ? `Can not load options: ${textifyError(this.state.loadingError)}` : ''}
        </div>
      </div>
    );
  }
}

export default SelectBase;
